export enum AuthRouteEnum {
  LOGIN = 'login',
  REGISTER = 'register',
  ONEID = 'oneid',
  FORGET_PASSWORD = 'forget-password',
}
